import { DashboardDesktopView } from './DashboardDesktopView';

export function DashboardTabletView() {
  return <DashboardDesktopView />;
}
